// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3vN94","title":"BackImages_title__1aL8x","images":"BackImages_images__36afY"};